var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogOut = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25,
  fill: "none",
  viewBox: "0 0 21 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.781 12.574h8.887m0 0-3.809 3.808m3.809-3.808-3.809-3.808"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#202124",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M19.667 4.957v-1.27a2.54 2.54 0 0 0-2.539-2.539H4.433a2.54 2.54 0 0 0-2.538 2.54V21.46a2.54 2.54 0 0 0 2.538 2.539h12.695a2.54 2.54 0 0 0 2.539-2.54V20.19"
})));
export default SvgLogOut;